// export default function dateToIndonesia(date) {
//   const d = new Date(date);
//   const dtf = new Intl.DateTimeFormat("en", {
//     year: "numeric",
//     month: "short",
//     day: "2-digit"
//   });
//   const [{ value: mo }, , { value: da }] = dtf.formatToParts(d);

//   return `${da} ${mo}`;
//   // return date;
// };

export default function formatDateIdn(tanggal: string) {
  return new Intl.DateTimeFormat('id-ID', { day: '2-digit', month: 'long', year: 'numeric' }).format(new Date(tanggal));
};
